import React from 'react';
import { useTranslation } from 'react-i18next';

import { GroupPic, PlaceholderImage } from '@assets/images';

import Img from '@components/atoms/Img';
import Text, { FontFamilyVariant, TextType } from '@components/Text';
import { isPlatformLanguageArabic } from '@common/domain/models/User';
import './styles.less';

const ReasonSection = () => {
    const { t } = useTranslation();
    return (
        <div className="reason-section">
            <Img alt="guest page why learn with wadhwani" className="guest-image" src={GroupPic}/>
            <div className={`guest-description-image ${isPlatformLanguageArabic() && 'ar-guest-description-image'}`}>
                <Text
                    className="reason-text"
                    fontFamilyVariant={FontFamilyVariant.bold}
                    text={t('guestView.labelsAndTitles.SECTION_TITLE2')}
                    textType={TextType.display2}
                />
                <Text
                    className="reason-text-description"
                    textType={TextType.h8}
                    fontFamilyVariant={FontFamilyVariant.regular}
                    text={t('guestView.labelsAndTitles.SECTION_DESCRIPTION2')}
                />
            </div>
        </div>
    )
}

export default ReasonSection;
